import React from 'react'
import {useHistory} from 'react-router-dom'
import {Button, Result} from 'antd'

const SuccessCom = () => {
  const history = useHistory()

  return (
    <>
      <Result
        status="success"
        title="注册成功"
        className="setPwdResult"
        extra={
          <Button
            type="primary"
            size="large"
            onClick={() => history.push('/login')}
            className="goLoginButton"
          >
            去登录
          </Button>
        }
      />
    </>
  )
}

export default SuccessCom
